import PropTypes from 'prop-types';
import styled from 'styled-components';
import React from 'react';
import * as styles from './tabs.css';
import TabMenu from './tab-menu';
import TabPanel from './tab-panel';

const TabsBody = styled.div`
  flex-grow: 1;
  padding: ${p => p.needsPadding && '8px'};
  border: 1px solid #e2e2e2;
  border-top: none;
`;

const Tabs = ({
  children,
  activeTabKey,
  tabChange,
  shouldRenderAllTabs = true,
  needsPadding = true,
  boltTitle = false,
}) =>
  <div className={styles.tabs}>
    <div className={styles.header}>
      {React.Children?.map(children, child =>
        <TabMenu
          tabMenuKey={child.props.tabKey}
          active={child.props.tabKey === activeTabKey}
          text={child.props.title}
          select={tabChange}
          boltTitle={boltTitle}
        />,
      )}
    </div>
    <TabsBody needsPadding={needsPadding}>
      {React.Children?.map(children, child =>
        shouldRenderAllTabs || child.props.tabKey === activeTabKey ?
          <TabPanel content={child.props.children} active={child.props.tabKey === activeTabKey} />
          : null,
      )}
    </TabsBody>
  </div>;
Tabs.propTypes = {
  activeTabKey: PropTypes.string,
  children: PropTypes.node,
  tabChange: PropTypes.func,
  shouldRenderAllTabs: PropTypes.bool,
  needsPadding: PropTypes.bool,
  boltTitle: PropTypes.bool,
};

export default Tabs;
